import { Observable } from 'rxjs';
import { RequestRoot } from 'types';

export class WizardTab {
  id: number;
  paths: Array<string>;
  name: string;
  icon: string;
  visible: () => boolean;
  activate: (active: boolean) => void;
  key: string;
  hasPath(paths: Array<string>): boolean {
    for (const this_path of this.paths) {
      for (const path of paths) {
        if (path.startsWith(this_path)) {
          return true;
        }
      }
    }
    return false;
  }
}

export abstract class WizardContext {
  abstract getTabs(): Array<WizardTab>;
  abstract registerTab(tab: WizardTab): void;

  abstract getDataURLs(): Array<string>;
  abstract registerDataURL(url: string): void;

  abstract getToolbarVisible(): boolean;
  abstract setToolbarVisible(toolbarVisible: boolean): void;

  abstract getRequestFeaturesTemplate(): any;
  abstract setRequestFeaturesTemplate(requestFeaturesTemplate: any): void;

  abstract registerModelListener(listener: () => void): number;
  abstract unregisterModelListener(listenerId: number): void;
  abstract notifyModelListeners(): void;

  abstract getUserData<T>(key: string): T | undefined;
  abstract setUserData<T>(key: string, value: T): void;
}

export function fetchWizardContext(data: any): WizardContext {
  return data.wizardContext;
}

export abstract class AppContext {
  abstract storeDraft(request: RequestRoot): void;
  abstract getDraft(request: RequestRoot | null): RequestRoot | null;
  abstract clearDraft(request: RequestRoot | null): void;
  abstract clearDrafts(): void;

  abstract getLocale(): string;
  abstract getI18NString(key: string): string;

  abstract getMessageSink(): (mode: 'ERROR' | 'WARN' | 'INFO', key: string) => void;
  abstract getMessageBox(confirm: boolean): (key: string, callback: (res: boolean) => void) => void;
  abstract getValidationWarningMessageBox(): (content: string[], callback: (res: boolean) => void) => void;

  abstract changeMessageSinkVisibleRef(visible: boolean): void;
  abstract changeMainMenuVisibleRef(visible: boolean): void;

  abstract getSettingFlag(flag: string): boolean;
  abstract getSettingText$(setting: string): Observable<string>;
  abstract getAppCertTail(): string;

  abstract openDataWizard(request: RequestRoot): void;
  abstract openPassportVerifyWizard(request: RequestRoot | null): void;
  abstract closeWizard(): void;
  abstract closeOnNavigation(closed: Observable<any>, close: () => void): void;

  abstract debug(): boolean;

  abstract getRequestStatusesEnumTemplate(): any;
}

export abstract class PrintersProvider {
  abstract getPrintersName(): Observable<string[]>;
  abstract storeDefaultPrinter(val: string): Observable<void>;
  abstract getDefaultPrinter(): Observable<string | null>;
}
